import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import eyeIcon from "../../assets/images/icons/eye.png"; // Eye icon for show password
import eyeOffIcon from "../../assets/images/icons/eye1.png"; // Eye icon for hide password
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoginAdmin } from "../../services/authServices";
import {
  Error,
  LoginContain,
  LoginFooter,
  RequiredStar,
} from "../../style/Login/AdminLogin";

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    adminId: "",
    password: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    setCredentials((prevState) =>
      prevState[name] !== value ? { ...prevState, [name]: value } : prevState
    );
  };

  const validateForm = () => {
    let formErrors = {};
    if (!credentials.adminId.trim())
      formErrors.adminId = "Admin ID is required";
    if (!credentials.password.trim())
      formErrors.password = "Password is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const response = await LoginAdmin({ payload: credentials });
      toast.success("Login successful");
      navigate("/admin-dashboard");
    } catch (error) {
      localStorage.clear();
      toast.error(error?.response?.data?.error ?? "Something went wrong");
    }
    setIsSubmitting(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState); // Toggle the password visibility
  };

  return (
    <>
      <ToastContainer />
      <LoginContain>
        <div className="LoginCard">
          <div className="LoginLogo">
            <img src={Logo} alt="logo"  loading="lazy" />
          </div>
          <div className="LoginTitle">
            <h4>Admin Login</h4>
            <p>Please login to your admin account.</p>
          </div>
          <form onSubmit={handleSubmit}>
            {/* Admin ID Field */}
            <div className="LoginGroup">
              <label htmlFor="adminId">
                Admin ID <RequiredStar>*</RequiredStar>
              </label>
              <input
                type="text"
                id="adminId"
                name="adminId"
                value={credentials.adminId}
                placeholder="Enter Your ID"
                onChange={handleInputChanges}
              />
              {errors.adminId && <Error>{errors.adminId}</Error>}
            </div>

            {/* Password Field */}
            <div className="LoginGroup">
              <label htmlFor="password">
                Password <RequiredStar>*</RequiredStar>
              </label>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"} // Toggle input type
                  id="password"
                  name="password"
                  value={credentials.password}
                  placeholder="Enter Your Password"
                  onChange={handleInputChanges}
                />
                <img
                  src={showPassword ? eyeOffIcon : eyeIcon} // Toggle icon
                  alt="toggle password visibility"
                  className="password-toggle-icon"
                  onClick={togglePasswordVisibility} // Toggle visibility on click
                   loading="lazy"
                />
              </div>
              {errors.password && <Error>{errors.password}</Error>}
            </div>

            {/* Forgot Password Link */}
            <div className="LoginGroup CheckBox">
              <Link to="/forgot">Forgot Password?</Link>
            </div>

            {/* Submit Button */}
            <div className="LoginGroup LoginBtn">
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Logging in..." : "Login"}
              </button>
            </div>
          </form>
        </div>
      </LoginContain>

      {/* Footer */}
      <LoginFooter>
        <p>
          POWERED BY: <span>Manthan IT Solutions</span>
        </p>
      </LoginFooter>
    </>
  );
};

export default AdminLogin;
